import { drawerOnToggle, onOffDrawerMenu } from './Drawer';
// @ts-ignore
import initMra from './MustReadArticles/mra-swiper.js';
import initFooter from './Footer';

const init = () => {
  // drawerOnToggle();
  // onOffDrawerMenu();

  initFooter();
  initMra();
};

export default init;

export { drawerOnToggle, onOffDrawerMenu };
